import React from 'react';

const Breadcrumb = ({ segments = [], title }) => (
  <nav aria-label="breadcrumbs p-0 m-0">
    <ol className="breadcrumb">
      {segments.map((segment, i) => {
        const key = `breadcrumb-${segment.name}-${i}`;
        return segment.url ? (
          <li className="breadcrumb-item" key={key}>
            <a href={segment.url}>{segment.name}</a>
          </li>
        ) : (
          <li className='breadcrumb-item active' key={key}>
            <h1 suppressHydrationWarning>
              {title || segment.name}
            </h1>
          </li>
        );
      })}
    </ol>
  </nav>
);

export default Breadcrumb;
